export default __webpack_public_path__ + "static/media/S1.895c8d59.svg";